"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles = {
    // Key exists for targeting during style merge
    root: {},
    label: {
        fontSize: "0.75rem",
        fontWeight: 500,
        marginBottom: 0,
        color: "#344054",
        ".dark-shelf &": {
            color: "white",
        },
    },
    select: {
        appearance: "none",
        position: "relative",
        borderRadius: ".375rem",
        color: "#2b2b2b",
        padding: "0.625rem 0.875rem",
        paddingRight: "2.25rem",
        border: "1px solid #D0D5DD",
        fontWeight: 500,
        fontSize: "0.875rem",
        // Apply this so implementers may use containers and layouts to determine button size, as well as overrides
        width: "100%",
        ".dark-shelf &": {
            color: "#f5f5f5",
            borderBottom: "1px solid #f5f5f5 !important",
        },
    },
    selectContainer: {
        position: "relative",
        width: "100%",
    },
    icon: {
        position: "absolute",
        top: "50%",
        transform: "translateY(-50%)",
        right: "0.75rem",
        pointerEvents: "none",
        color: "#667085",
        width: "1rem",
    },
};
exports.default = styles;
//# sourceMappingURL=selectStyles.js.map